import React, { useEffect } from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import {
    handleCloseSelectForm,
    handleOnchangeForm,
} from './handler/HelpdeskCreateTicketHandler';
import { handleOpenSelectForm } from './handler/QaTicketHandler';
import { getFormFromFormListById } from './handler/TicketHandler';
import PropTypes from 'prop-types';

InvitationGuestOrGuestCustomer.propTypes = {
    selectedForm: PropTypes.any,
    errorCreateTicket: PropTypes.any,
    formList: PropTypes.any,
    detailTicket: PropTypes.any,
    setIsLoading: PropTypes.any,
    userDetail: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    isOpenSelectForm: PropTypes.any,
};

export default function InvitationGuestOrGuestCustomer(props) {
    let selectedForm = props.selectedForm;

    useEffect(() => {
        (async () => {
            props.setIsLoading(true);
            let userDetail = props.userDetail;
            let workLastForm = Utils.convertJSONDataToObject(userDetail.workLastForm);
            let lastFormOfProject = workLastForm[props.projectInuseDetail.id];
            let switchFormId = props?.selectedForm ? props.selectedForm : '';

            if (lastFormOfProject) {
                let lastFormInviteOfProject = lastFormOfProject[Constant.TYPE_LAST_FORM.LAST_FORM_INVITED];
                if (!Utils.isEmptyObject(lastFormInviteOfProject)) {
                    // Validate Form
                    let selectedFormDetail = await getFormFromFormListById(
                        lastFormInviteOfProject?.formId
                    );
                    let isLastFormNotValid = Utils.isEmptyObject(selectedFormDetail) || !selectedFormDetail.usingProjects.includes(props.projectInuseDetail.id);
                    
                    if (!isLastFormNotValid && !switchFormId) {
                        switchFormId = lastFormInviteOfProject?.formId;
                    }
                }
            }

            if (switchFormId) {
                let e = {
                    target: {
                        dataset: {
                            value: switchFormId
                        }
                    }
                }
                await handleOnchangeForm(e, {
                    ...props,
                    selectedForm: ''
                })
            }
            props.setIsLoading(false);
        })();
    }, []);

    return (
        <div className="form-addTicket helpdesk-create-invite">
            <label className="form-addTicket-label">フォーマット</label>
            <div className="form-addTicket-input" data-cy="qa-ticket-select-form">
                <TextField
                    className="form-control form-control--wrap form-control--hg40"
                    select
                    variant="outlined"
                    name="selectedForm"
                    value={selectedForm ? selectedForm : ''}
                    defaultValue={selectedForm ? selectedForm : ''}
                    required
                    errorlist={props.errorCreateTicket}
                    SelectProps={{
                        value: selectedForm,
                        open: props.isOpenSelectForm,
                        onClose: e => handleCloseSelectForm(props),
                        onOpen: e => handleOpenSelectForm(props),
                        MenuProps: {
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null,
                            className: "selectDrop"
                        }
                    }}
                    disabled={!Utils.isEmptyString(props.detailTicket?.deletedAt)}
                >
                    {Utils.isEmptyArray(props.formList) && (
                        <MenuItem style={{ display: 'none' }}></MenuItem>
                    )}

                    {!Utils.isEmptyArray(props.formList) &&
                        props.formList?.map(item => {
                            return (
                                <MenuItem
                                    key={item?.id}
                                    value={item?.id}
                                    onClickCapture={e => {
                                        handleOnchangeForm(e, props, item?.id);
                                        e.stopPropagation();
                                    }}
                                >
                                    <OverFlowTooltipWithTabsMui
                                        value={Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            item?.name
                                        )}
                                    />
                                </MenuItem>
                            );
                        })}
                </TextField>
            </div>
        </div>
    );
}
